import styled, { css } from 'styled-components';
import { prop } from 'ramda';

import { Color, Spacing, Media, Grid, FontWeight } from '../../theme';
import { styleWhenTrue } from '../../utils';
import { HeaderH4style } from '../header/header.component';

import {
  ContentContainerData,
  ContainerData,
  HeaderSectionData,
  InnerContainerData,
} from './sectionContainer.types';
import { ContentWidth } from './sectionContainer.enums';

export const Container = styled.div<ContainerData>`
  max-width: ${Grid.DesktopWide};
  margin: 0 auto;
  a {
    text-decoration: none;
  }
  & + & {
    margin-top: ${(props: ContainerData) => props.spaceBetween ? props.spaceBetween : '0'};
  }
`;

export const HeadersContainer = styled.div``;

export const InnerContainer = styled.div<InnerContainerData>`
  padding: 0 ${Spacing.DesktopWide};
  display: flex;
  justify-content: space-between;
  position: relative;
  max-width: ${Grid.DesktopNarrow};
  ${Media.desktop`
    padding: 0 ${Spacing.Desktop};
  `}
  ${Media.tablet`
    flex-direction: column;
    padding: 0 ${Spacing.Tablet};
  `}
  ${styleWhenTrue(prop('fullContentWidthOnMobile'), css`
    ${Media.tablet`
      padding: 0;
    `}
  `)}
`;

export const HeaderSection = styled.div<HeaderSectionData>`
  width: 300px;
  ${Media.desktop`
    width: 250px;
  `}
  ${Media.tablet`
    width: 100%;
  `}
  ${styleWhenTrue(prop('fullContentWidthOnMobile'), css`
    ${Media.tablet`
      padding: 0 ${Spacing.Tablet};
      width: calc(100% - 2 * ${Spacing.Tablet});
    `}
  `)}
`;

export const PrimaryHeaderMain = styled.h2`
  ${HeaderH4style}
  padding-top: 40px;
  border-top: 2px solid ${Color.primary};
  ${Media.tablet`
    margin-right: 0;
  `}
`;

export const PrimaryHeaderAdditional = styled.h3`
  font-size: 18px;
  font-weight: ${FontWeight.Light};
  letter-spacing: 0;
  line-height: 26px;
  color: ${Color.darkSilver};
  margin-top: 18px;
`;

export const SecondaryHeaderMain = styled(PrimaryHeaderAdditional)`
  border-top: 1px solid ${Color.darkSilver};
  margin: 0;
  padding-top: 28px;
`;

export const SecondaryHeaderImage = styled.img`
  max-height: 150px;
  max-width: 100%;
  margin-top: 20px;
`;

export const ContentContainer = styled.div<ContentContainerData>`
  width: calc(100% - 350px);
  margin-left: 50px;
  position: relative;
  ${styleWhenTrue(prop('isGridModeEnable'), css`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 2fr));
    grid-gap: 5px;
  `)}
  max-width: ${(props: ContentContainerData) =>
    props.widthMode === ContentWidth.FullWidth ? 'unset' : '680px'
  };
  ${Media.desktop`
    width: calc(100% - 300px);
  `}
  ${Media.tablet`
    margin-left: 0;
    margin-top: 60px;
    width: 100%;
  `}
`;
